import React from 'react';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';

import './_EntityBlockEmptyState.scss';

const EntityBlockEmptyState = () => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return <div className="EntityBlockEmptyState">{T.translate('NO_LINKS_MESSAGE')}</div>;
};

export default EntityBlockEmptyState;
